import { EmptyState, ExclamationmarkIcon, Grid, GridColumn, GridRow, ProfileIcon } from '@bp/ui-components';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseFormType } from './CourseForm';
import styles from './CourseForm.module.scss';

type CourseProfilesFormProps = {
  step: number;
  onHint: (hint: string | null) => void;
};

export const CourseProfilesForm = ({ step, onHint }: CourseProfilesFormProps) => {
  const { t } = useTranslation();

  const { values } = useFormikContext<CourseFormType>();

  const { editors, viewers } = values;

  useEffect(() => {
    if (step === 1) {
      if (editors.length === 0 && viewers.length === 0) {
        onHint(t('courses.noProfilesHint'));
      } else {
        onHint(t('courses.personSelectHint'));
      }
    } else {
      onHint(null);
    }
  }, [editors.length, onHint, step, t, viewers.length]);

  return (
    <Grid className={styles['profiles-form']} useFormGap>
      {editors.length === 0 && viewers.length === 0 ? (
        <EmptyState className={styles.warning} icon={<ExclamationmarkIcon />} title={t('courses.noProfiles')} />
      ) : (
        <>
          <GridRow>
            <GridColumn width={6}>
              <div className={styles.headline}>{`${t('courses.profilesWithEditorRole')} (${editors.length})`}</div>
              {editors.length === 0 ? (
                <EmptyState padding='l' size='small' icon={<ProfileIcon />} subtitle={t('persons.noPerson')} />
              ) : (
                <ol className={styles.list}>
                  {editors.map((e) => {
                    return (
                      <li className='mb-1' key={e.profileUuid}>
                        {e.name}
                      </li>
                    );
                  })}
                </ol>
              )}
            </GridColumn>
            <GridColumn width={6}>
              <div className={styles.headline}>{`${t('courses.profilesWithMemberRole')} (${viewers.length})`}</div>
              {viewers.length === 0 ? (
                <EmptyState padding='l' size='small' icon={<ProfileIcon />} subtitle={t('persons.noPerson')} />
              ) : (
                <ol className={styles.list}>
                  {viewers.map((v) => {
                    return (
                      <li className='mb-1' key={v.profileUuid}>
                        {v.name}
                      </li>
                    );
                  })}
                </ol>
              )}
            </GridColumn>
          </GridRow>
        </>
      )}
    </Grid>
  );
};
